import { Column as ColumnIcon, IconButton, Item, MultiSelect } from "@bcc-ui/ui-components";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { AssetColumn, DEFAULT_COLUMN_KEYS } from "services/asset-management/AssetService";
import { createTranslatorPath } from "services/pathTranslator";

interface Props {
    setHiddenColumns: (hiddenColumns: string[]) => void;
    columns: AssetColumn[];
    hiddenColumns: string[];
}

export const AssetColumnSelector = (props: Props) => {
    const { t } = useTranslation();
    const [resetKey, setResetKey] = useState(0);

    const translatedPaths = createTranslatorPath(useTranslation, "assetPaths");

    const items: Item[] = props.columns.map((column) => ({
        value: column.key,
        label: translatedPaths(column.apiPath),
    }));

    const selectedItems: Item[] = items.filter((item) => !props.hiddenColumns.includes(item.value.toString()));

    const handleSelectionChange = (newSelection: Item[]) => {
        const resolvedSelection =
            newSelection.length > 0
                ? newSelection
                : items.filter((item) => DEFAULT_COLUMN_KEYS.includes(item.value.toString()));
        const selectedKeys = resolvedSelection.map((item) => item.value);
        const columnsToHide = props.columns
            .filter((column) => !selectedKeys.includes(column.key))
            .map((column) => column.key);
        props.setHiddenColumns(columnsToHide);
        if (newSelection.length === 0) {
            setResetKey((prev) => prev + 1);
        }
    };

    return (
        <MultiSelect
            key={`asset-columns-${items.length}-${resetKey}`}
            selectAllByDefault={false}
            allSelectedText={""}
            multiselectText={t("AssetManagement.columnsSelected")}
            onSelectedChange={handleSelectionChange as (value: Item[] | string[]) => void}
            values={items}
            preselectedValues={selectedItems}
            customTriggerElement={
                <IconButton>
                    <ColumnIcon />
                </IconButton>
            }
            dropdownPosition="bottom-end"
            noneSelectedText={t("AssetManagement.allColumns")}
            selectAllCheckboxLabel={t("AssetManagement.allColumns")}
        />
    );
};
